<template>
    <div class="loading-mask" v-loading="yjctrl" element-loading-text="您已拖欠运营商佣金，为了不影响正常使用，请尽快补交！">
        <div class="simple-row">
            <div class="right">
                <a class="swb-btn swb-btn-small swb-btn-primary" v-app-url="'/call/bid/list/jsp'" target="_blank">招标市场</a>
            </div>
        </div>

        <swb-call-bid-doc-search @showSearch="showSearch"></swb-call-bid-doc-search>

        <table class="custom-tbl">
            <thead class="head">
            <tr class="row">
                <th>招标书标题</th>
                <th>招标方</th>
                <th>招标开始时间</th>
                <th>招标结束时间</th>
                <th>发布时间</th>
                <th>操作</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row" v-for="bidEnroll in bidEnrollList">
                <td style="text-align: left">
                    <a class="swb-btn-link" @click="toCallBidDocInfo(bidEnroll.id,bidEnroll.openTime)">{{bidEnroll.title}}</a>
                </td>
                <td>{{bidEnroll.merchantName}}</td>
                <td>{{bidEnroll.openTime}}</td>
                <td>{{bidEnroll.closeTime}}</td>
                <td>{{bidEnroll.publishTime}}</td>
                <td>
                    <div>
                        <a class="swb-btn-link" v-if="checkActionPerm('view_notice')" @click="lookNotice(bidEnroll.id)"> 查看招标书公告</a>
                        <!--<a class="swb-btn-link" v-if="checkTime(bidEnroll.publishTime) && !checkTime(bidEnroll.enrollCloseTime)" @click="signUpJudge(bidEnroll.id)">报名</a>-->
                        <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toCallBidDocInfo(bidEnroll.id,bidEnroll.openTime)">查看详细信息</a>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <div class="pagination-layout">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import callBidApi from '../../api/callBid'
    import tendBidApi from '../../api/tendBid'
    import merchtComnApi from '../../api/merchtComn'

    import { checkUserActionPerm } from '../index'
    import { getDefaultPageSizes } from '../../app.conf'

    import SwbCallBidNoticeList from './CallBidNoticeList';
    Vue.regist(SwbCallBidNoticeList);

    import SwbBidEnrollSignUp from './BidEnrollSignUp';
    Routes.add(SwbBidEnrollSignUp);

    import SwbCallBidDocInfo from './CallBidDocInfo';
    Routes.add(SwbCallBidDocInfo);

    import SwbBidMarketList from './BidMarketList';
    Routes.add(SwbBidMarketList);

    import SwbCallBidDocSearchLet from './CallBidDocSearchLet';
    Vue.regist(SwbCallBidDocSearchLet);

    export default {
        name: 'swb-orienteering-call-bid-list',
        path: '/call/bid/doc/directed/list',
        pathOld: '/bid/market/list',
        avlActions: 'view_notice|view',
        avlActionNames: '查看招标书公告、查看详细信息、招标市场',
        avlScopes: 'servicer',
        desc: '定向招标书列表',
        helpArticleCode: 'servicer-call-bid-doc-directed-list',
        data: function () {
            return {
                //分页信息
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //排序、搜索
                queryConfig: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                bidEnrollList: [],
                title: null,
                searchShow: false,
                dateStart: null,
                dateEnd: null,
                //
                yjctrl: false, //
            }
        },
        created: function () {
            // ----------------------------分页-----------------------
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //---------------------------查询-------------------------
            this.getOrienteeringCallBidList();
            //
            this.getMerchantCtrlParamValue();
        },
        methods: {
            showSearch: function (data) {
                this.queryModel = data;
                this.pageNumber = 1;
                this.getOrienteeringCallBidList();
            },

            getMerchantCtrlParamValue: function () {
                let self = this;
                let postData = {};
                postData.code = getEnumInfoWith("ctrlParamCode", "name", "DueBidCtrl").code;
                merchtComnApi.getMerchantCtrlParamValue(postData, function (result) {
                    if(result.type == 'info') {
                        //
                        self.yjctrl = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getOrienteeringCallBidList();
            },

            searchTag: function (tag) {
                this.sndPartyFlag = tag;
                this.searchShow = true;
                this.getOrienteeringCallBidList();
            },

            getOrienteeringCallBidList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                callBidApi.getCallBidDocAppointList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.bidEnrollList = result.data.rows;
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    }
                });
            },
            // 报名前检查是否已经报名
            signUpJudge: function (callDocId) {
                let self = this;
                tendBidApi.checkBidEnroll(callDocId, function (result) {
                    if(result.type == 'info') {
                        self.signUp(callDocId);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            signUp: function (callDocId) {  // 跳转到报名信息页
                this.$router.push({
                    path: SwbBidEnrollSignUp.path,
                    query: {
                        callDocId: callDocId
                    }
                });
            },
            toCallBidDocInfo: function (callBidDocId, openTime) { // 跳转招标书详细信息界面
                this.$router.push({
                    path: SwbCallBidDocInfo.path,
                    query: {
                        callBidDocId: callBidDocId,
                        resultFlag: false,
                        openTime: openTime,
                        checkStateValue: null
                    }
                });
            },

            checkTime: function (time) {
                var currTime = new Date();
                var dbTime = new Date(time);

                if(currTime.getTime() >= dbTime.getTime()) {
                    return true;
                } else if(currTime.getTime() < dbTime.getTime()) {
                    return false;
                }
            },
            lookNotice: function (id) {
                let self = this;
                Vue.$showDialog({
                    title: '公告列表 - 查看',
                    showCloseBtn: true,
                    width: 900,
                    height: 700,
                    template: '<div>' +
                    '<swb-call-bid-notice-list :docId="docId" ref="swb_call_Bid_notice_list"></swb-call-bid-notice-list>' +
                    '</div>',
                    data: {
                        docId: id,
                    },
                    okClicked: function () {
                    },
                    okVisible: false,
                    method: {},
                    lifecycle: {}

                });
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/callbid/OrienteeringCallBidList.vue